<template>
    <main
        class="relative flex min-h-[calc(100vh-var(--headerHeight))] items-center justify-center overflow-hidden bg-[linear-gradient(135deg,rgba(3,24,55,0.98),rgba(4,26,67,0.96))] px-4 py-8 sm:px-5 sm:py-16"
    >
        <div
            class="pointer-events-none absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.025)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.025)_1px,transparent_1px)] bg-[size:48px_48px] [mask-image:linear-gradient(to_bottom,black,transparent_85%)]"
            aria-hidden="true"
        ></div>
        <div class="absolute -left-32 -top-36 h-96 w-96 rounded-full bg-[#3159ff] opacity-[0.18] blur-[120px]" aria-hidden="true"></div>
        <div class="absolute -bottom-48 -right-40 h-96 w-96 rounded-full bg-[#3159ff] opacity-[0.18] blur-[120px]" aria-hidden="true"></div>

        <section
            class="relative z-[1] w-full max-w-[46rem] rounded-[1.25rem] border border-white/[0.13] bg-white/[0.97] px-5 py-9 text-center shadow-[0_2rem_5rem_rgba(0,0,0,0.26)] sm:rounded-3xl sm:p-14"
            aria-labelledby="comeback-heading"
        >
            <div class="mx-auto mb-6 flex h-[4.5rem] w-[4.5rem] items-center justify-center rounded-full bg-[#e9edff] text-[#263fd4]" aria-hidden="true">
                <svg class="h-11 w-11" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M24 5L39 11V22C39 31.8 32.8 40.4 24 43C15.2 40.4 9 31.8 9 22V11L24 5Z" stroke="currentColor" stroke-width="2.5" />
                    <path d="M17.5 24L22 28.5L31.5 19" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>

            <p class="mb-3 text-[0.8rem] font-bold uppercase tracking-[0.16em] text-[#263fd4]">{{ $translate(content.eyebrow) }}</p>
            <h1 id="comeback-heading" class="mx-auto mb-5 max-w-[38rem] text-[clamp(2rem,5vw,3.25rem)] leading-[1.08] text-[#031837]">{{ $translate(content.heading) }}</h1>
            <p class="mx-auto max-w-xl text-base leading-[1.7] text-[#526078] sm:text-lg">
                {{ $translate(content.intro) }}
            </p>

            <div class="my-8 flex items-start gap-3 rounded-2xl border border-[#cbd5ff] bg-[#f0f3ff] p-4 text-left text-[#031837] sm:gap-4 sm:p-5">
                <svg class="w-7 min-w-7 text-[#263fd4]" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M12 7V12L15 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                    <circle cx="12" cy="12" r="8.5" stroke="currentColor" stroke-width="1.8" />
                </svg>
                <div>
                    <strong class="mb-1 block text-[1.05rem]">{{ $translate(content.noticeHeading) }}</strong>
                    <span class="block leading-[1.55] text-[#526078]">{{ $translate(content.noticeText) }}</span>
                </div>
            </div>

            <p class="m-0 text-[0.95rem] leading-[1.55] text-[#526078]">{{ $translate(content.footer) }}</p>
        </section>
    </main>
</template>

<script setup>
const content = {
    eyebrow: {
        de: 'ComebackPrämie',
        en: 'Comeback reward'
    },
    heading: {
        de: 'Ihr Gratis-Abo bleibt Ihnen erhalten.',
        en: 'Your free subscription is safe.'
    },
    intro: {
        de: 'Wir stellen derzeit auf unser neues System um. Deshalb ist die Einlösung Ihrer ComebackPrämie vorübergehend nicht möglich.',
        en: 'We are currently migrating to our new system. During this transition, you will temporarily be unable to redeem your comeback reward.'
    },
    noticeHeading: {
        de: 'Keine Sorge: Ihre Prämie verfällt nicht.',
        en: 'Rest assured: Your reward will not expire.'
    },
    noticeText: {
        de: 'Die Einlösung ist in den nächsten Tagen wieder möglich.',
        en: 'Redemption will be available again within the next few days.'
    },
    footer: {
        de: 'Sie müssen nichts weiter tun. Besuchen Sie diese Seite einfach in ein paar Tagen erneut.',
        en: 'No action is required. Simply return to this page in a few days.'
    }
};
</script>
